import React from 'react';

import Button from 'core/modules/atoms/Button';
import { InputText, FormField } from 'ui';


const RecoverForm = () => {
  // deprecated
  return (
    <div className="login-form">
      <div className="login-form__item">
        <h3 className="login-form__title">Recover Password</h3>
      </div>
      <div className="login-form__item">
        <FormField label="Email">
          <InputText placeholder={t('auth:Username')} />
        </FormField>
      </div>
      <div className="login-form__item">
        <Button text="Recover Password" />
      </div>
    </div>
  );
};

export default RecoverForm;
